/* eslint-disable no-alert */
import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import useWindowSize from '@/hooks/useWindowSize';
import { Currency } from '@/icons/index';
import CardShapesBusiness from '@/icons/CardShapesBusiness';
import SvgArrow from '@/icons/Arrow';
import Button from '../Button/Button';
import Details from './Details';
import CellData from './CellData';
import LinkNumbers from '../LinkNumbers/LinkNumbers';

import styles from './styles.module.scss';

const BusinessTariffCard = ({ data, handleConnect }) => {
  const [width] = useWindowSize();
  const [active, setActive] = useState(false);
  const tariffDetails = useRef();
  const showDetails = () => {
    setActive(!active);
  };

  const renderPrice = () => {
    if (data?.button_type === 'pop-up') {
      return (
        <Button
          size={'normal'}
          Component={'button'}
          onClick={handleConnect}
          className={`bkc-gtm_business_tracking ${styles.button}`}
          name={data?.name}
        >
          {data?.button_text}
        </Button>
      );
    }

    return width > 768 ? (
      <Button
        size={'normal'}
        Component={data?.button_slug ? 'a' : 'router'}
        href={data?.button_slug ? data?.button_slug : data?.external_link}
        className={styles.button}
      >
        {data?.button_text}
      </Button>
    ) : (
      <Button
        size={'normal'}
        Component={'a'}
        href={`tel:${data?.ussd}`}
        className={`bkc-gtm_business_tracking ${styles.button}`}
        name={data?.name}
      >
        {data?.button_text}
      </Button>
    );
  };
  return (
    <div
      className={classNames([styles.tariff, { [styles.active]: active }])}
      itemScope
      itemType='https://schema.org/Product'
    >
      {(data?.name || data.ussd) && (
        <div className={styles['tariff-head']}>
          <div className={styles['tariff-head__content']}>
            <div className={styles.topWrapper}>
              <span> {data?.name && data?.name}</span>
              <div className={styles.rectangle}></div>
            </div>
            <CardShapesBusiness />

            {/* {label && <div className={styles.label}>{label}</div>} */}
            <div
              className={classNames(styles['price-box'], {
                [styles.line]: data.individual_customers_price,
              })}
            >
              {(data?.corporate_customers_price ||
                data?.individual_customers_price) && (
                <>
                  {data.individual_customers_price && (
                    <div className={styles['price-box__content']}>
                      <div className={styles.title}>
                        {data?.individual_customers_price_title}
                      </div>
                      <div className={styles.all}>
                        <span className={styles.price}>
                          {data?.individual_customers_price}
                        </span>
                        <span className={styles.currency}>
                          <span className='currency'>
                            <Currency />
                          </span>
                          {data?.price_text}
                        </span>
                      </div>
                    </div>
                  )}
                  <div
                    className={classNames(
                      styles['price-box__content'],
                      !data?.individual_customers_price &&
                        styles['price-box__content__hidden'],
                    )}
                  >
                    <div className={styles.title}>
                      {data?.corporate_customers_price_title}
                    </div>
                    <div className={styles.all}>
                      <span className={styles.price}>
                        {data?.corporate_customers_price}
                      </span>
                      <span className={styles.currency}>
                        <span className='currency'>
                          <Currency />
                        </span>
                        {data?.price_text}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>
            {!!data.ussd && (
              <div className={styles.numbers}>
                <LinkNumbers numbers={data.ussd} isTel />
              </div>
            )}
          </div>
        </div>
      )}

      <div className={styles.tariff__content}>
        {/* {calls && (
          <div className={styles['content-head']}>
            <CellData data={calls} />
          </div>
        )} */}
        <div className={styles.cellContainer}>
          {!!data.sections?.length &&
            data.sections.map((item, key) => (
              <CellData data={item} key={key} />
            ))}
          {data?.details?.sections && active && (
            <div
              className={classNames([styles.detailsContainer])}
              ref={tariffDetails}
            >
              <Details data={data?.details} />
            </div>
          )}
        </div>
        {data?.additions?.length > 0 && (
          <div className={styles.additional}>
            {data?.additions?.map((item) => (
              <div key={item}>{item}</div>
            ))}
            {/* {data?.corporate_customers_price && (
              <div className={styles.additional__price}>
                {data?.corporate_customers_price}
                {
                  <span className='currency'>
                    <Currency />
                  </span>
                }
              </div>
            )}
            {data.price_text && data.price_text} */}
          </div>
        )}
        <div className={styles.bottom}>
          {data?.details?.button_text &&
            data?.details?.sections?.length > 0 && (
              <div onClick={showDetails} className={styles.bottom__content}>
                {/* {!!prices.length && prices.map(renderPrices)} */}
                <div className={styles['details-button']}>
                  <SvgArrow className={active && styles.active} />
                  {data?.details.button_text}
                </div>
              </div>
            )}

          {renderPrice()}
        </div>
      </div>
    </div>
  );
};

export default BusinessTariffCard;
